import { StyledSection } from '@components/layouts/Layouts';
import { SEARCH } from '@modules/routes/constants';
import PublicationButtonSearch from '@modules/shared/components/publications/PublicationButtonSearch';
import { useRouter } from 'next/router';

export const HomeSearchSection = () => {
  const router = useRouter();

  return (
    <StyledSection>
      <PublicationButtonSearch onClick={() => router?.push(SEARCH)} />
    </StyledSection>
  );
};
